/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { useUserStore } from '@/store';

export default function access() {
  const { permissionsList } = useUserStore.getState();

  // 将权限列表转为对象，并处理逗号分隔的权限
  const permissionObj = permissionsList.reduce<Record<string, boolean>>((acc, perm) => {
    perm.split(',').forEach((key) => {
      const trimmedKey = key.trim();
      if (trimmedKey) {
        acc[trimmedKey] = true;
      }
    });
    return acc;
  }, {});

  return permissionObj;
}
